import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteFooter } from "@/components/SiteNav";
import { TAX_ANSWERS, KIND_LABEL, type AnswerKind } from "@/lib/tax-answers";

const URL = "https://mytaxfella.com/tax-answers";
const TITLE = "Tax Answers: IRS Notices, NY & NJ Letters, Tax Terms | MyTaxFella";
const DESC =
  "Plain-language answers to IRS notices like CP14, CP504, and CP2000, NY and NJ state tax letters, resolution terms, and common tax questions.";

export const Route = createFileRoute("/tax-answers/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE }, { property: "og:image", content: "https://mytaxfella.com/og-share-2026.jpg" }, { name: "twitter:image", content: "https://mytaxfella.com/og-share-2026.jpg" },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Tax Answers",
          url: URL,
          hasPart: TAX_ANSWERS.map((a) => ({ "@type": "WebPage", name: a.h1, url: `${URL}/${a.slug}` })),
        }),
      },
    ],
  }),
  component: TaxAnswersIndex,
});

const ORDER: AnswerKind[] = ["irs-notice", "state-notice", "term", "question"];

function TaxAnswersIndex() {
  return (
    <main>
      <section className="section-y">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
          <h1 className="section-h2">Tax Answers</h1>
          <p className="mt-5 text-lg text-muted-foreground max-w-2xl leading-relaxed">
            Got a letter from the IRS or the state? Find your notice below for what it means, the deadline, and what
            to do next, written by the MyTaxFella team.
          </p>
        </div>
      </section>
      {ORDER.map((kind, i) => (
        <section key={kind} className={`section-y-compact ${i % 2 === 0 ? "bg-card border-y border-border" : ""}`}>
          <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
            <h2 className="section-h2 !text-2xl md:!text-3xl">{KIND_LABEL[kind]}</h2>
            <ul className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {TAX_ANSWERS.filter((a) => a.kind === kind).map((a) => (
                <li key={a.slug}>
                  <Link
                    to="/tax-answers/$slug"
                    params={{ slug: a.slug }}
                    className="pc-card flex h-full flex-col gap-2 transition-colors hover:border-green"
                  >
                    <span className="font-semibold text-foreground">{a.h1}</span>
                    <span className="text-sm text-muted-foreground line-clamp-3">{a.summary}</span>
                    <span className="mt-auto pt-2 text-sm font-semibold text-green">Read the answer →</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>
      ))}
      <SiteFooter />
    </main>
  );
}
